import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Spinner, Compass } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const token = params.get("token");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setStatus("error");
      setMessage("This confirmation link is invalid.");
      return;
    }
    api
      .post("/auth/verify-email", { token })
      .then((res) => {
        setStatus("success");
        setMessage(res.data.message || "Email confirmed!");
      })
      .catch((e) => {
        setStatus("error");
        setMessage(formatApiErrorDetail(e.response?.data?.detail) || "We couldn't confirm your email.");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="verify-email-page">
        <Link to="/" className="inline-flex items-center gap-2 mb-8"><Compass size={26} weight="duotone" className="text-[#2E523A]" /><span className="font-display text-xl font-bold">TravelNext</span></Link>
        {status === "verifying" && (
          <>
            <Spinner size={56} className="text-[#2E523A] mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-3xl font-bold">Confirming your email…</h1>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle size={72} weight="fill" className="text-[#2E523A] mx-auto mb-6" data-testid="verify-success" />
            <h1 className="font-display text-4xl font-bold">You're all set!</h1>
            <p className="text-[#63675E] mt-3">{message}</p>
            <Link to="/login"><Button className="rounded-full bg-[#2E523A] hover:bg-[#26442f] mt-8 h-12 px-8" data-testid="verify-go-login">Sign in</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={72} weight="fill" className="text-destructive mx-auto mb-6" data-testid="verify-error" />
            <h1 className="font-display text-3xl font-bold">Confirmation failed</h1>
            <p className="text-[#63675E] mt-3">{message}</p>
            <Link to="/login"><Button variant="outline" className="rounded-full mt-8 h-12 px-8" data-testid="verify-error-login">Back to sign in</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
